import { useConfigStore, useFacilityStore } from '@/stores';
import styles from './styles.module.scss';
import ShopFnbFacilityCategoryButton from '@/components/common/shop-fnb-facility/buttons/category';
import { useFacilityCategories } from '@/hooks/poi/useFacilityData';
import type { BuildingCategory } from '@/services/dto';
import { useTranslation } from 'react-i18next';
import { FACILITY_SEARCH_MODE } from '@/enums/facility';

interface FacilitySearchByCategoryProps {
    onSelectCategory?: (category: BuildingCategory) => void;
}

const FacilitySearchByCategory = ({ onSelectCategory }: FacilitySearchByCategoryProps) => {
    const language = useConfigStore((state) => state.config.ui.language);

    const { t } = useTranslation();
    const selectedBuildingId = useFacilityStore((state) => state.selectedBuildingId);
    const selectedCategory = useFacilityStore((state) => state.selectedCategory);
    const setSelectedCategory = useFacilityStore((state) => state.setSelectedCategory);
    const updateFacilityContents = useFacilityStore((state) => state.updateFacilityContents);
    const facility = useFacilityCategories(selectedBuildingId || 'all');

    const handleSelectCategory = (category: BuildingCategory) => {
        setSelectedCategory(category);
        onSelectCategory?.(category);
        updateFacilityContents(FACILITY_SEARCH_MODE.SEARCH_BY_CATEGORY);
    };

    return (
        <div data-region-name="fnb-search-by-category" className={styles['fnb-search-by-category']} data-region-nav>
            {facility?.map((category) => (
                <ShopFnbFacilityCategoryButton
                    tabIndex={9}
                    data-interactive
                    role="radio"
                    type="button"
                    aria-checked={selectedCategory?.clientCode === category.clientCode}
                    aria-label={category.clientCode === 'all' ? t(category.name[language]) : category.name[language]}
                    key={category.clientCode}
                    title={category.clientCode === 'all' ? t(category.name[language]) : category.name[language]}
                    onClick={() => handleSelectCategory(category)}
                />
            ))}
        </div>
    );
};

export default FacilitySearchByCategory;
